import LoanCalculator from "@/components/LoanCalculator";

export default function LoanCalculatorPage() {
  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#ff5a00] mb-3">Rahoitus</p>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight mb-4">Rahoituslaskuri</h1>
        <p className="text-white/50 max-w-xl mb-12 leading-relaxed">
          Arvioi auton kuukausierä helposti. Säädä hintaa, käsirahaa ja laina-aikaa —
          laskuri päivittää kuukausierän reaaliajassa. Korko on kiinteä 5,9 %.
        </p>
        <LoanCalculator />
      </div>
    </div>
  );
}
